































































import Vue from 'vue';
import JourneySummary from './JourneySummary.vue';
import {Component, Prop} from 'vue-property-decorator';
import Axios from "axios";
import {IRefundStatusJourney, IRefundStatusResponse} from "./IRefundStatusJourney";
import {IJourneyDetails} from "./JourneyDetails";
import VueInsProgressBar from 'vue-ins-progress-bar';
import RefundUnavailable from "./RefundUnavailable.vue";
import ManualRefundRequired from "./ManualRefundRequired.vue";
import {CrsConverter} from "./CrsConverter";
import Accordion from "./Accordion.vue";
import InstantRefundNoReplacement from "./InstantRefundNoReplacement.vue";
import RefundWithReplacement from "./RefundWithReplacement.vue";
import RefundComplete from "./RefundComplete.vue";
import RefundUtil from './RefundUtil';
import Modal from "./Modal.vue";
import RefundPreamble from "./RefundPreamble.vue";
import {IRefundSuccess} from "./IRefundSuccess";

@Component({
    components: {
        RefundPreamble,
        RefundComplete,
        RefundWithReplacement,
        InstantRefundNoReplacement,
        ManualRefundRequired,
        RefundUnavailable,
        JourneySummary,
        VueInsProgressBar,
        Accordion,
        Modal
    }
})
export default class RefundView extends Vue {
    refundStatus: IRefundStatusJourney = null;
    dryRunRefund: IRefundSuccess = null;
    feeFree: boolean = false;
    errorFetchingData: FetchError = null;
    crsConverter: CrsConverter = null;
    currencyFormatter: Intl.NumberFormat;
    protectedReference: string = null;
    replacementProtectedReference: string = null;
    finished: boolean = false;
    refundUtil = new RefundUtil();
    showingFeeFreeModal: boolean = false;
    fetchedDryRun: boolean = false;
    deferred: boolean = false;
    sixMonthReached: boolean = false;
    @Prop() details: IJourneyDetails;
    @Prop() refundStatusUrl: string;
    @Prop() dryRunUrl: string;
    @Prop() appealsEmail: string;

    created() {
        this.currencyFormatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        });

        this.$insProgress.start();
        this.fetchRefundStatus();
        this.doRefundDryRun();
        this.parseCrsMap();
    }

    private parseCrsMap() {
        let crsMapElement = document.getElementById("crsMap");
        if (crsMapElement === null) {
            throw new Error("CRS map JSON element was not on the page");
        }
        this.crsConverter = new CrsConverter(crsMapElement);
    }

    private fetchRefundStatus() {
        Axios.get<IRefundStatusResponse>(this.refundStatusUrl).then(
            (response) => {
                console.log("received response", response.data);
                const deserialised = response.data as IRefundStatusResponse;
                if (deserialised == null) {
                    this.errorFetchingData = new FetchError("null response, no matching journey", null);
                }
                this.refundStatus = deserialised.refundStatus;
                this.feeFree = deserialised.isFeeFree;
                this.protectedReference = deserialised.protectedReference;
                this.replacementProtectedReference = deserialised.replacementProtectedReference;
                this.$insProgress.finish();
            }).catch((error) => {
                console.error(error);
                if (error.response && error.response.data !== null) {
                    console.log("Making fetchError with body");
                    this.errorFetchingData = new FetchError(error.toString(), error.response.data);
                } else {
                    this.errorFetchingData = new FetchError(error, null);
                }
                this.$insProgress.finish();
            }
        );
    }

    wasPrinted() {
        return this.refundStatus && this.refundStatus.isPrinted;
    }

    acceptInstantRefund(defer: boolean = false) {
        this.deferred = defer;
        if (this.protectedReference) {
            this.$insProgress.start();
            const parsedSearch = new URLSearchParams(window.location.search);
            Axios.post<ConfirmRefundRequest, Object>(
                "/api/ProcessRefund",
                new ConfirmRefundRequest(
                    this.protectedReference,
                    this.refundStatus.journeyID,
                    window.location.search.toLowerCase().indexOf("covid19") !== -1,
                    defer,
                    parsedSearch.has('disruptedOutwards') && parsedSearch.get('disruptedOutwards') === 'true',
                    parsedSearch.has('disruptedInwards') && parsedSearch.get('disruptedInwards') === 'true',
                )
            ).then(
                (response) => {
                    console.log("received response", response.data);
                    this.$insProgress.finish();
                    this.finished = true;
                }).catch((error) => {
                    if (error.response && error.response.data !== null) {
                        console.log("Making fetchError with body");
                        this.errorFetchingData = new FetchError(error.toString(), error.response.data);
                    } else {
                        this.errorFetchingData = new FetchError(error, null);
                    }

                    this.$insProgress.finish();
                }
            );
        } else {
            console.error("Backend does not think a refund is possible");
        }
    }

    private doRefundDryRun() {
        Axios.get<IRefundStatusResponse>(this.dryRunUrl).then(
            (response) => {
                console.log("received dry-run response", response.data);
                this.dryRunRefund = response.data as IRefundSuccess;
                this.fetchedDryRun = true;
            }).catch((error) => {
                console.error(error);
                if (error.response && error.response.data && error.response.data.indexOf('older than 6 months') !== -1) {
                    this.sixMonthReached = true;
                }
                this.dryRunRefund = null;
                this.fetchedDryRun = true;
                this.$insProgress.finish();
            }
        );
    }
}

export class FetchError {
    details: string;
    body: string;

    constructor(details: string, body: string) {
        this.details = details;
        this.body = body;
    }

}

export class ConfirmRefundRequest {
    public protectedReference: string;
    public journeyId: string;
    public covid19: boolean;
    public defer: boolean;
    public disruptedOutwards: boolean;
    public disruptedInwards: boolean;

    constructor(protectedReference: string, journeyId: string, covid19: boolean, defer: boolean, disruptedOutwards: boolean, disruptedInwards: boolean) {
        this.protectedReference = protectedReference;
        this.journeyId = journeyId;
        this.covid19 = covid19;
        this.defer = defer;
        this.disruptedOutwards = disruptedOutwards;
        this.disruptedInwards = disruptedInwards;
    }
}
